import React from 'react'
import { Grid, IconButton } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { styles } from './ResultsPaginationStyles'

function ResultsPagination({
  totalResultsCount,
  handleNext,
  handlePrevious,
  resultsPageOffset,
  resultPagesArray,
  resultPageLimit,
  setResultPageOffset,
}) {
  const classes = styles({
    resultsPageOffset,
    resultPagesArray,
    resultPageLimit,
  })

  const getVisiblePages = () => {
    const totalPages = resultPagesArray.length
    const current = resultsPageOffset / resultPageLimit
    const windowSize = 10

    let start = current - Math.floor(windowSize / 2)
    let end = current + Math.floor(windowSize / 2)

    if (start < 0) {
      end += -start
      start = 0
    }

    if (end > totalPages - 1) {
      start -= end - (totalPages - 1)
      end = totalPages - 1
      if (start < 0) start = 0
    }

    const pages = []
    if (start > 0) {
      pages.push(0)
      if (start > 1) pages.push('start-ellipsis')
    }

    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    if (end < totalPages - 1) {
      if (end < totalPages - 2) pages.push('end-ellipsis')
      pages.push(totalPages - 1)
    }

    return pages
  }

  return (
    <Grid className={classes.paginationMainGrid}>
      {totalResultsCount > 0 && (
        <IconButton onClick={handlePrevious} disabled={resultsPageOffset === 0}>
          <ArrowBackIosIcon className={classes.ArrowBackIosIcon} />
        </IconButton>
      )}

      <Grid className={classes.paginationDottedButtons}>
        {getVisiblePages().map((p, index) => {
          if (p === 'start-ellipsis' || p === 'end-ellipsis') {
            return (
              <Grid
                key={index}
                className={classes.paginationNumberedButtonsChild}
              >
                …
              </Grid>
            )
          }

          return (
            <Grid key={p} className={classes.paginationNumberedButtonsChild}>
              <Grid
                className={classes.paginationStyle}
                style={{
                  color:
                    p === resultsPageOffset / resultPageLimit
                      ? '#00B7A4'
                      : '#262A4C',
                }}
                onClick={() => setResultPageOffset(p * resultPageLimit)}
              >
                {p + 1}
              </Grid>
            </Grid>
          )
        })}
      </Grid>

      {totalResultsCount > 0 && (
        <IconButton
          onClick={handleNext}
          disabled={
            resultPagesArray.length - 1 === resultsPageOffset / resultPageLimit
          }
        >
          <ArrowForwardIosIcon
            className={classes.ArrowForwardIosIcon}
            disabled={resultPagesArray.length - 1 < 0}
          />
        </IconButton>
      )}
    </Grid>
  )
}

export default ResultsPagination
